/**
 * Nudge per arrow click. Roughly one sector wide — labels vary in length, so a
 * fixed step is deliberate rather than snapping to a chip boundary.
 */
export const SCROLL_STEP_PX = 100;

/**
 * Width of the gradient cap each scroll arrow sits in — the design's 109px
 * fade rectangle. Wide enough that labels dissolve into the page background
 * before they reach the arrow rather than being cut mid-word.
 */
export const FADE_CAP_WIDTH = '109px';

/** Horizontal gap between sector labels, matching the design's 28px. */
export const SECTOR_GAP = '7';

/** Vertical padding of the scroll row, keeping it 40px tall like the design. */
export const SECTOR_ROW_PADDING_Y = '2.5';
